import { normalizePageParam } from "@/lib/helpers/parsers";
import { GET } from "@/lib/methods";
import {
  objectToQueryString,
  removeUndefinedProperties,
} from "@/lib/utilities";
import type { DietSearchResultsType } from "../types/diet-search-resilts.type";
import type { SearchResultsFiltersType } from "../types/dites-filtes.type";

export const getSearchResults = (
  filters: Partial<SearchResultsFiltersType> = {},
) => {
  const parsedFilters = removeUndefinedProperties(filters);
  const queryString = objectToQueryString({
    ...parsedFilters,
    lowestPrice: true,
    page: normalizePageParam(filters?.page),
  });

  return GET<DietSearchResultsType>({
    url: `${process.env.NEXT_PUBLIC_CATALOG_URL}/search_result_items${queryString}`,
    params: {
      next: {
        tags: ["diets_search_results", queryString],
        revalidate: 3600,
      },
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
};
